import { LOGIN_RESPONSE_ERROR } from 'common/constants/login';
import { CARD_NAME } from 'common/constants/card';
import { MOBILITY_NAME } from 'common/constants/mobility';
import { USER_RESPONSE_ERRORS } from 'entities/user';

const translates = {
  "yes": "Yes",
  "no": "No",
  "ok": "Ok",
  "apply": "Apply",
  "save": "Save",
  "cancel": "Close",
  "company": "Company",
  "details": "Details",
  "name": "Name",
  "email": "E-mail",
  "phoneNumber": "Phone",
  "volume": "Volume",
  "download": "Download",
  "print": "Print",
  "downloadFile": "Download file",
  "station": "Station",
  "brand": "Brand",
  "gpsLongitude": "Longitude",
  "gpsLatitude": "Latitude",
  "gpsLongitudeAndLatitude": "Latitude, longitude",
  "stationCategory": "Station category",
  "suitableForTrucks": "Available for trucks",
  "address": "Address",
  "route": "Route",
  "prices": "Prices",
  "reset": "Reset",
  "whereFrom": "From where",
  "where": "Where",
  "noData": "No data",
  "filter": "Filter",
  "legend": "Legend",
  "exit": "Exit",
  "login": "Login",
  "password": "Password",
  "requestAccess": "Request Access",
  "enter": "Login",
  "nip": "Tax id. no. (NIP)",
  "shares": "Special offers",
  "showResult": "Show result",
  "additionalParameters": "Additional parameters",
  "typeOfRoadsideService": "Type of roadside service",
  "offerAgreement": "Contract offer",
  "paymentInvoice": "Invoice",
  "aboutE100Card": "About E100 card",
  "orderCard": "Order a card",
  "stationActive": "Ordinary",
  "stationDiscont": "Discount+",
  "stationPM": "Power MAX",
  "stationEconom": "Economy",
  "store": "Roadside service",
  "stationSale": "Promotional refuel station",
  "cluster": "Several gas stations at",
  "stationInfo": "Service point information",
  "stationAddress": "Station address",
  "stationNotes": "Station notes",
  "priceUpdated": "Price is updated",
  "country": "Country",
  "relevantOn": "Current on",
  "delete": "Delete",
  "additionalServices": "Additional services",
  "additionalServices.subtitle": "Without the use of a fuel card",
  "buildingRoute.buildRoute": "Build a route",
  "buildingRoute.routeDetails": "Route details",
  "login.toTheE100Website": "Back to site",
  "east.login.toTheE100Website": "Back to site",
  "login.logInToPersonalAccount": "Log in",
  "login.goBackToPersonalAccount": "Client Login",
  "login.orderCard": "Order a card",
  "login.account": "Account",
  "login.unauthorizedUser": "Unauthorized user",
  "print.listOfRouteServicePoints": "List of services on the route",
  "print.listOfRouteServicePointsWithPrices": "List of services on the route with prices",
  "buildingRoute.stationsFoundOnRoute": "Found stations on route",
  "buildingRoute.bestPriceInCountryOnRoute": "Best price in {country} on the route",
  "buildingRoute.intermediatePoint": "Intermediate point",
  "buildingRoute.addPoint": "Add point",
  "buildingRoute.addPoint.infoMessage": "You can add a maximum of 8 intermediate points",
  "buildingRoute.error.noSuchCityOrCountry": "There is no such city or country",
  "buildingRoute.error.impossibleToBuildRoute": "Impossible to plot a route",
  "buildingRoute.error.noStartAndEndPointsSelected": "It is impossible to plot a route. Start and end points are not selected.",
  "buildingRoute.error.noStartingPointSelected": "It is impossible to plot a route. Start point are not selected.",
  "buildingRoute.error.noEndpointSelected": "It is impossible to plot a route. End point are not selected.",
  "filter.additionalParameters": "Additional options",
  "filter.gasStationBrand": "Gas station brand",
  "filter.findGasStationBrand": "Find gas station brand",
  "filter.findCountry": "Find a country",
  "filter.selectCountry": "Choose a country",
  "filter.findRegion": "Find Region",
  "filter.region": "Region",
  "filter.servicesAtStation": "Station services",
  "filter.serviceFormat": "Service format",
  "filter.stationCategory": "Station category",
  "filter.findTrack": "Find Track",
  "filter.track": "Track",
  "filter.gasStationFilter": "Filter of the stations",
  "filter.listSP": "List of stations",
  "filter.displayListOfSP": "Display stations list",
  "filter.displayListOfSPWithPrices": "Display stations list with prices",
  "filter.listSPWithPrices": "List of stations with prices",
  "filter.stationFilter": "Filter of the stations",
  "filter.filterResetModal.title": "Reset filter",
  "filter.filterResetModal.text": "Are you sure you want to reset the settings?",
  "filter.authorizationLink1": "To view prices, please",
  "filter.authorizationLink2": "log in",
  "stationInfo.priceUpdated": "Price updated",
  "languages.ru": "Русский",
  "languages.lt": "Lietuvių",
  "languages.en": "English",
  "languages.tr": "Türkçe",
  "languages.pl": "Polski",
  "languages.uk": "Український",
  "languages.es": "Español",
  "changeLanguage": "Change language",
  "orderCardsModal.unitMeasureFuelValume": "l./month",
  "orderCardsModal.possibleLending": "Crediting is possible",
  "orderCardsModal.privacyPoliceDescription": "I agree to e-mail contact",
  "orderCardsModal.representativeOfLegalEntity": "I agree to be contacted via phone",
  "orderCardsModal.privacyPoliceModal.title": "Consent to be contacted by Email",
  "orderCardsModal.privacyPoliceModal.text": "I consent to the processing by E100 International Trade Sp. z o.o. my personal data in the form of an e-mail address for the purpose of sending me marketing information regarding products and services offered by E100 International Trade Sp. z o.o. by means of electronic communication, pursuant to the provisions of art. 10 sec. 1 and 2 of the Act on the provision of electronic services. Detailed rules regarding the processing of personal data and marketing consents are set out in the information clause. Before giving marketing consent, please read its content.",
  "orderCardsModal.representativeOfLegalEntityModal.title": "Consent to be contacted by phone",
  "orderCardsModal.representativeOfLegalEntityModal.text": "I consent to the processing of my personal data in the form of the telephone number provided by me by E100 International Trade Sp. z o.o. in order to conduct marketing activities with the use of telecommunications terminal equipment and automatic calling systems within the meaning of the Telecommunications Law. Detailed rules regarding the processing of personal data and marketing consents are set out in the information clause. Before giving marketing consent, please read its content.",
  "orderCardsModal.orderCard": "Order a card",
  "orderCardsModal.sendRequest": "Send a request",
  "orderCardsModal.description": "Would you like to test E100 fuel card for free? Fill out the form and we will contact you to clarify the terms of delivery.",
  "orderCardsModal.title": "Order a card for free",
  "orderCardsModal.cardCount": "Number of cards",
  "orderCardsModal.prePay": "Prepayment amount",
  "orderCardsModal.prePay.recommendedAmount": "The recommended prepayment amount is 1000 rubles.",
  "orderCardsModal.totalAmount": "Total amount",
  "orderCardsModal.finishRegistration": "Finish registration",
  "orderCardsModal.formSentSuccess": "The order has been sent",
  "orderCardsModal.ru.secondStep.title": "Ordering fuel cards and issuing a payment document",
  "orderCardsModal.ru.thirdStep.title1": "Your order has been accepted,",
  "orderCardsModal.ru.thirdStep.title2": "our manager will contact you soon.",
  "orderCardsModal.ru.thirdStep.subtitle": "Thank you for choosing E100!",
  "orderCardsModal.ru.thirdStep.numberOfCards": "Number of E100 cards",
  "orderCardsModal.ru.thirdStep.prePay": "Prepayment amount",
  "orderCardsModal.ru.thirdStep.description1": "Below you can find a commercial proposal,",
  "orderCardsModal.ru.thirdStep.description2": "a contract offer, and an invoice for payment.",
  "orderCardsModal.ru.thirdStep.conditionTitle": "draw your attention to",
  "orderCardsModal.ru.thirdStep.conditionText1": "Payment of the invoice is acceptance of the terms of the contract offer.",
  "orderCardsModal.ru.thirdStep.conditionText2": "In each invoice in the column 'purpose of payment,' it is necessary to indicate the number of your contract offer. Your contract offer number.",
  "stationSearch.title": "Search (gas station code, coordinates, address)",
  "stationInfo.availableAtGasStations": "Available at petrol stations",
  "stationInfo.aboutStation": "About station",
  "stationInfo.refillsByCard": "Refueling by fuel card",
  "stationInfo.serviceDescriptionForSpain": "* The price includes a discount from the Spanish government of 0.20 € (valid until 12/31/2022).",
  "error.fieldCannotBeEmpty": "The field cannot be empty",
  "error.fieldCannotBeNull": "The field cannot be equal to 0",
  "error.onlyLatinLettersAndNumbers": "Only Latin numbers and letters",
  "error.allowedNumberCharacters": "The allowed number of characters",
  "erorr.emailNotValid": "Е-mail is not valid",
  "error.invalidCharacter": "Invalid character",
  "error.phoneNotValid": "The phone number is not valid",
  "error.emptyServicePointCodeList": "Select at least one service point",
  "error.emptySendInEmailList": 'Select “Send in email” for at least one service point',
  "error.emptyServiceList": "Select at least one service",
  "error.emptyTimeRangeList": "Time range must be selected",
  "error.invalidTimeRange": "Time range is not valid",
  [`error.${LOGIN_RESPONSE_ERROR.userOrPasswordInvalid}`]: 'Invalid data',
  [`error.${LOGIN_RESPONSE_ERROR.accessError}`]: 'Please contact your E100 regional manager',
  [`error.${LOGIN_RESPONSE_ERROR.passwordNeedsToBeReplaced}`]: 'Your password must be changed',
  [`error.${LOGIN_RESPONSE_ERROR.loginTemporarilyBlocked}`]: 'The ability to enter was blocked for 15 minutes.',
  [`error.${LOGIN_RESPONSE_ERROR.loginFromWrongTerritory}`]: 'Incorrect login credentials entered. Please call the hotline',
  [`error.${USER_RESPONSE_ERRORS.blockedUser}`]: 'The account of user {userName} has been temporarily locked. Instructions to restore the account have been sent to the primary email associated with the Contract.',
  "error.startAndEndDates": "The end date and time shall be later than the start date and time",
  "error.rangeStartAndEndDates": "Search range cannot exceed 7 days",
  "error.dateRange": "The selected date range must not exceed {range} days.",
  "km": "km",
  "m": "m",
  "loading": "Loading...",
  "filter.closeWindow.text": "Are you sure you want to close the window (the parameters will be reset)",
  "hours": "h.",
  "min": "min.",
  "days": "days",
  "Min": "Min",
  "Max": "Max",
  "24/7": "24 hours a day",
  "withoutTechnicalBreaks": "Without taking into account technical breaks",
  "workingHours": "Working hours",
  "monday": "MO",
  "tuesday": "TU",
  "wednesday": "WE",
  "thursday": "TH",
  "friday": "FR",
  "saturday": "SA",
  "sunday": "SU",
  "weekend": "Closed",
  "noWorkHours": "There are no data on working hours",
  "refuelingMode": "Access method",
  "avoid": "Avoid",
  "highways": "Highways",
  "tolls": "Tolls",
  "ferries": "Ferries",
  "netto.serviceDescription": `The Net price on the ${CARD_NAME} invoice may differ depending on the local time of the station, as well as due to rounding, currency conversions, devaluation processes, and the time of arrival at the refuel stations.`,
  "includeNettoPrices": "Include Net price",
  "confirmSubmitFilterFormModal.title": "Attention",
  "confirmSubmitFilterFormModal.text1": "The stations shown may have gas stations that only support refueling through a mobile application.",
  "confirmSubmitFilterFormModal.text2": "Pay attention to the \"Refueling mode\" filter.",
  "confirmSubmitFilterFormModal.link": `Learn more about ${MOBILITY_NAME}`,
  "brutto": "Incl. VAT",
  "netto": "Excl. VAT",
  "availableServicesAtStation": "Available services at the station",
  "copy": "Copy",
  "replicate": "Copy",
  "copied": "Copied",
  "authModal.title": "Log in",
  "authModal.info": "Dear Customer! In order to protect your account from fraudsters, the ability to enter will be blocked for 15 minutes in case you enter an incorrect login or password more than 10 times",
  "map": "Map",
  "satellite": "Satellite",
  'feedbackModal.addReview': 'Leave a review',
  'feedbackModal.attachFile': 'Attach a file',
  'feedbackModal.fileMaxSize': 'Files in the following formats can be attached PNG, JPG, PDF, MOV, MPEG. Total volume of files should not exceed 25 MB.',
  'feedbackModal.review': 'Your review',
  'feedbackModal.fileMaxSizeErr': 'The file was not added. Total size of the files exceeds {size} MB',
  'feedbackModal.contactPhone': 'Contact phone number',
  'feedbackModal.contactEmail': 'Contact email address',
  'feedbackModal.reviewInfoMsg': 'Leave feedback about the Client Portal',
  'feedbackModal.reviewInfoMsg2': 'Write your review about the work of your personal account to improve our service.',
  'feedbackModal.send': 'Send',
  'feedbackModal.cancel': 'Cancel',
  'feedbackModal.name': 'Name',
  'feedbackModal.phoneOrEmail': 'Contact email or phone number',
  "feedbackModal.fieldCannotBeEmpty": "Field can not be empty",
  "feedbackModal.invalidPhoneNumber": "Invalid phone number",
  "feedbackModal.invalidEmail": "Invalid email address",
  "feedbackModal.success": "Thank you. Your review was sent",
  "feedbackModal.error": "Something went wrong. Please try again later.",
  "somethingGoWrong": "Something went wrong",
  "e100OnlineMessage.title": "Only mobile app usage is available",
  "e100OnlineMessage.description": 'Only the E100 mobile app can be used. Plastic cards are not accepted. Learn more: ',
  "locatorSettings": "Locator settings",
  "netPriceDisplay": "Display of NET prices",
  "autoScaling": "Autoscaling",
  "servicePointDisplayRadius": "Radius for displaying service stations on the route",
  "servicePointDisplayRadius.label": "Radius in km",
  "differentPrice.title": 'The sign "~" indicates that the cost may vary depending on the selected product or service.',
  "showCars": "Show vehicles",
  "hideCars": "Hide vehicles",
  "showDrivers": "Show drivers",
  "hideDrivers": "Hide drivers",
  "attention": "Attention! ",
  "fullCardNumber": "Full card number",
  "longtitudeAndLatitude": "Latitude and longitude",
  "driverDeviceDate": "Date on the driver’s device",
  "receivedCoordinatesDate": "Date of coordinate receipt",
  "lastCoordinatesReceived": "Last coordinates received",
  "driverFullName": "Driver's full name",
  "driverPhoneNumber": "Driver’s phone number",
  "driverPhoneNumber.description": "To display driver’s phone number information, change the authorization method in the Mobile App to access via phone number.",
  "driverAutoNumber": "Vehicle registration number",
  "driverAutoNumber.description": "The vehicle number can be changed in the Personal Account",
  "secureEBox": "Secure E-BOX",
  "clientCars.modal.text1": "Do you want to see the location of your vehicles in the E100 locator?",
  "clientCars.modal.text2": "Login and activate the Secure E-BOX service.",
  "clientCars.modal.text3": "Activate the Secure E-BOX service.",
  "clientCars.modal.text4": "Do you want to check your vehicles' travel thistory using the E100 locator?",
  "auto": "Vehicle",
  "card": "Card",
  "OBU": "OBU",
  "coordinates": "Coordinates",
  "updateTime": "Update time",
  "moreDetailed": "More details",
  "reports": "Reports",
  "routeFilterReports": "Route/filter reports",
  "pricesReports": "Price reports",
  "preparationForExport": "Export preparation",
  "readyToDownload": "Ready to download",
  "hasStationLimitBeenExceeded": "The number of stations should not exceed 1000",
  "reportErrorTooltip": "An error occurred, please try again",
  "hideStations": "Hide Stations",
  "showStations": "Show Stations",
  "comment": "Comment",
  "share": "Share",
  "sharedStationLinkModal.text1": "Write a comment for the driver (optional).",
  "sharedStationLinkModal.text2": "Send the copied text to the driver in any convenient way (for example, through messaging apps).",
  "shareStationLinkMessage.text1": "Share information about the gas station",
  "shareStationLinkMessage.text2": "is here",
  "shareStationLinkMessage.text3": "If you don't have the app installed, be sure to download",
  "shareStationLinkMessage.text4": "Continue after installation",
  "messageCopied": "Text copied",
  "copyMessage": "Copy text",
  "cardsLinkedToOBU": "Cards linked to OBU",
  "showLinkedCards": "Show added cards",
  "routesHistory": "Route history",
  "routesHistory.empty": "No GPS data for the selected period (the device was turned off or not working)",
  "routesHistory.sectionsFilter.all": "All",
  "routesHistory.sectionsFilter.moving": "Movement",
  "routesHistory.sectionsFilter.stops": "Stops",
  "routesHistory.sectionsFilter.disconnects": "Disconnections",
  "autoNumber": "Vehicle registration plate",
  "showHistory": "Show history",
  "start": "Start",
  "end": "End",
  "communicationLackWithOBU": "No communication with OBU",
  "trafficStop": "Travel stop",
  "copyСoordinates": "Copy coordinates",
  "navigationHistoryStartLocationWarningMessage": "A discrepancy has been detected between the specified start date and the actual date when the first coordinate was received. <br /><br /> Perhaps, the OBU was switched off at the start time you've specified",
  "navigationHistoryEndLocationWarningMessage": "A discrepancy has been detected between the specified end date and the actual date when the last coordinate was received. <br /><br /> Perhaps, the OBU was switched off before the expiration of time you've specified",
  "driverLocations.attention": "We cannot guarantee the accuracy of coordinates (driver’s location) if the integrity of the system on their mobile device is compromised (e.g., rooted or jailbroken). Please keep this in mind when using the Fuel Station Locator.",
  "error.title": "An error occurred",
  "error.message": "Try opening favorites in a couple of minutes, or reload the tab.",
  "favouriteStations.emptyItems.warningTitle": "It's empty here for now",
  "favouriteStations.emptyItems.warningMessage": 'To add to the list, click "+" or use the add option in the service point card',
  "addOnlyThisServicePoint": "Add Service Point to Favorites",
  "deleteServicePointFromFavourites": "Remove the Service Point from Favorites",
  "addEntireBrand": "Add Brand to Favorites",
  "deleteBrandFromFavorites": "Remove the Brand from Favorites",
  "abilityToBeSelectedForYourManager": "The ability to manage favorites for your manager",
  "favourites": "Favorites",
  "favouriteStation": "Favorite service point",
  "favouriteStations": "Favorite service points",
  "favouriteBrands": "Favorite brands",
  "searchByLists": "Search by brand or SP code",
  "findStation": "Find the service point",
  "deleteFromFavorites": "Remove from favorites",
  "findBrand": "Find the brand",
  "favouriteStations.deleteModal.message": "Are you sure you want to remove this Service Point from the Favorites list?",
  "favouriteBrands.deleteModal.message": "Are you sure you want to remove the brand from the Favorites list?",
  "favouriteStations.added.message": 'The Service Point has been added to “Favorites”',
  "favouriteBrands.added.message": 'The brand has been added to “Favorites”',
  "addToFavourite": "Add to Favorites",
  "nothingWasFound": "Nothing found",
  "carSearch.title": 'Search (vehicle number, OBU)',
  "vehicleNumberOBU.notFound": "Vehicle number | OBU not found",
  "mapType": "Map type",
  "googleMap": "Google Maps",
  "hereMap": "HERE Maps",
  "autoPark": "Fleet",
  "fuelAssignment": "Fuel assignment",
  "fuelAssignmentFor": "Fuel assignment for {cardNumber}",
  "fuelAssignments": "Fuel assignments",
  "fuelAssignments.attentionMessage": "Want to create and manage fuel assignments for your drivers? Log in and get full access to features that help you efficiently manage fuel resources",
  "fuelAssignments.searchTitle": "Search: vehicle, station, name",
  "fuelAssignment.description": "Validity period: from 'Start date' 00:00 to 'End date' 23:59 (time in UTC+0)",
  "fuelAssignment.transactions.emptyList": "No transactions recorded under this assignment yet",
  "addFuelAssignment": "Create fuel assignment",
  "addFuelAssignment.title": "New fuel assignment",
  "addFuelAssignment.message": "Want to create and manage fuel assignments for your drivers? Log in and get full access to features that help you efficiently manage fuel resources.",
  "deleteFuelAssignment.title": "Delete fuel assignment",
  "deleteFuelAssignment.description1": "Do you really want to delete the fuel assignment for card {cardNumber}?",
  "deleteFuelAssignment.description2": "The fuel assignment will also be removed in the driver’s mobile app and cannot be restored.",
  "important": "Important!",
  "sortByStartDate": "Sort by start date",
  "ascendingOrder": "Ascending",
  "descendingOrder": "Descending",
  "planned": "Planned",
  "completed": "Completed",
  "partiallyCompleted": "Partially completed",
  "notCompleted": "Not completed",
  "findCard": "Find card",
  "car": "Vehicle",
  "startDate": "Start date",
  "endDate": "End date",
  "transactions": "Transactions",
  "title": "Name",
  "servicePoint": "Station",
  "service": "Service",
  "findService": "Find service",
  "literNumber": "Number of liters",
  "saveFuelTask": "Save fuel assignment",
  "copyTaskText": "Copy assignment text",
  "period": "Period",
  "placeHere": "{stationCode} is located here",
  "safeTrip": "Have a safe journey!",
  "fuelAssignments.planned.emptyList.description": "To add to the list, open the service point card and click on the button to create a fuel task",
  "fuelAssignments.completed.emptyList.description": "All completed fuel tasks will appear here",
  "fuelAssignments.notCompleted.emptyList.description": "All uncompleted fuel tasks will appear here",
  "fuelAssignments.emptyList.title": "Nothing here yet",
  "priceReport": "Price report",
  "servicePointCode": "Service point code",
  "update": "Update",
  "updated": "Updated",
  "configuration": "Settings",
  "sorting": "Sorting",
  "sorting.asc": "Ascending",
  "sorting.desc": "Descending",
  "priceReport.emptyReport.description": "Set up the price report and its delivery time",
  "configureReport": "Configure report",
  "preparingReport": "Preparing report",
  "loadingReport": "Report loading",
  "itMayTakeSomeTime": "This may take some time",
  "configuringReport": "Report settings",
  "stationsPriceReportSettings.servicePoints.title": "Service points in the price report",
  "stationsPriceReportSettings.servicePoints.description": "Prices for service points marked 'Send in email' are sent to email. Prices for all selected service points are shown in the Locator report",
  "stationsPriceReportSettings.sendInEmail": "Send in email",
  "addServicePoint": "Add service point",
  "added": "Added",
  "stationsPriceReportSettings.services.title": "Services in the price report",
  "addServices": "Add services",
  "stationsPriceReportSettings.emails.title": "Recipient email addresses",
  "addAddress": "Add address",
  "stationsPriceReportSettings.sendTime.title": "Email sending time",
  "stationsPriceReportSettings.sendTime.description": "The email sending time is based on your company’s time zone settings in the Client Portal",
  "add": "Add",
  "deleteReport": "Delete report",
  "reportGeneration": "Report generation",
  "reportGenerationIn": "Report generation in {time}",
  "reportWillAvailable": "Report generation with the new settings will be available in {time}",
  "pricesWithoutVAT": "Prices do not include VAT",
  "fuelPricesAndServices": "Fuel and service prices",
  "choseFuel": "Select fuel",
  "contactWithYourE100Manager": "Contact your E100 manager",
  "routeCostDetails": "Detailed information about route cost",
  "fuelCost": "Fuel cost",
  "averageConsumption": "Average consumption",
  "avgRouteCost": "Average route cost",
  "l.": "l",
  "routeCalculationTollDescription": "Route calculation including toll cost is available in the PRO plan",
  "totalCost": "Total cost",
  "distance": "Distance",
  "travelTime": "Travel time",
  "tollsCost": "Toll roads cost",
  "availableOnPRO": "Available in PRO subscription",
  "selected": "Selected",
  "bestPriceInRoute": "Best price in {countryCode}<br />on the route",
  "additionalSettings": "Additional settings",
  "showTollRoadCosts": "Show toll road costs",
  "tollRoads": "Toll roads",
  "avoidRoadTolls": "Avoid road tolls",
  "avoidFerryCrossings": "Avoid ferry crossings",
  "traffic": "Traffic",
  "fareParameters": "Fare parameters",
  "selectAdrClass": "Select ADR class",
  "routeBuildingPreferences": "Route building preferences",
  "avoidSelectedCountries": "Avoid selected countries",
  "servicesOnRoute": "Services along the route",
  "stationsOnRoute": "Service points along the route",
  "addToRoute": "Add to route",
  "removeFromRoute": "Remove from route",
  "allStations": "All service points",
  "updateRoute": "Update route",
  "itsEmptyHereForNow": "Nothing here yet",
  "selectedStationsOnRouteWillBeHere": "Service points added to the route will appear here",
  "chosen": "Selected",
  "priceReportIsNotConfigured": "Price report is not configured",
  "netPrice": "Net price",
  "selectedServicePointsOnRoute": "Selected service points along the route",
  "bestPrice": "Best price",
  "bus": "Bus",
  "axesNumber": "Number of axles",
  "currentWeight": "Current weight",
  "customVehicle": "Custom settings",
  "grossWeight": "Gross vehicle weight",
  "carHeight": "Vehicle height",
  "carWidth": "Vehicle width",
  "carLength": "Vehicle length",
  "weightPerAxle": "Axle load",
  "tiresCount": "Number of tires",
  "trailerAxesNumber": "Number of trailer axles",
  "emissionType": "Emission class",
  "co2EmissionClass": "CO2 emission class",
  "cm.": "cm",
  "kg.": "kg",
  "settings": "Settings",
  "acceptableValuesRange": "Allowed range of values: {range}",
  "myFleet": "My fleet",
  "switchToGoogleMaps": "Switch to Google Maps",
  "switchToHereMaps": "Switch to HERE Maps",
  "pricesReports.description": "Set up a report with a list of current prices at specific service points at a time convenient for you",
  "routeFilterReports.description": "Route/filter reports ready for download are available for 24 hours",
  "openReport": "Open report",
  "layers": "Layers",
  "showVehicles": "Show vehicles",
  "hideVehicles": "Hide vehicles",
  "more": "More",
  "invalidTrailerAxleCount": 'The field value must be less than the value in the "Number of axles" field',
  "mapLayers": "Map layers",
  "vehiclesOnMap": "Vehicles on map",
  "servicePointsOnMap": "Service points on map",
  "excise": "Excise",
  "costsDisplayedOnMap": "Prices displayed on the map",
  "routes.routesLoading": "Getting available routes...",
  "routes.stationsLoading": "Getting service points along routes...",
  "routes.pricesLoading": "Getting best prices at E100 service points...",
  "onRightSideOnly": "Exclude service points on the opposite side of the road",
  "stationsDisplay": "Displaying service points",
  "locationSharing": "Share location",
  "locationSharing.vehiclePlate": "Vehicle registration plate",
  "locationSharing.note": "Note",
  "locationSharing.generateLink": "Create link",
  "locationSharing.duration12h": "12 hours",
  "locationSharing.duration24h": "24 hours",
  "locationSharing.duration2d": "2 days",
  "locationSharing.duration7d": "7 days",
  "originalPrice": "Original price",
  "lowestPrice": "Lowest price",
  "stationsDisplayRadius": "Maximum distance of a service point from the planned route",
  "linkGenerated": "Link generated",
  "publishedLinks": "Published links",
  "note": "Note",
  "expiresIn": "Expires in",
  "link.active": "Active",
  "link.inactive": "Inactive",
  "link.finished": "Expired",
  "openLink": "Open link",
  "copyLink": "Copy link",
  "publicLinkFor": "Public link for",
  "deleteLink": "Delete link",
  "linkCopied": "Link copied",
  "linkDeleted": "Link deleted",
  "location": "Location",
  "moving": "Movement",
  "truckStop": "Truck parking",
  "disconect": "Connection lost",
  "carLocation": "Vehicle location",
  "updateOnPRO": "Upgrade to Pro",
  "locationSharingProPlan": "Upgrade your plan to access the vehicle’s location.",
  "isDeleteLink": "Delete the link?",
  "deleteLink.description": "After the link is deleted, external access to the vehicle’s movement history will no longer be available.",
  "searchVehicles": "Search vehicles",
  "locationStatus": "Location status",
  "locationStatusIsGotLess": "Last received less than {hours} h ago",
  "locationStatusFromTo": "Last received between {from} h and {to} h ago",
  "locationStatusIsGotMore": "Last received more than {hours} h ago",
  "disconnects": "Disconnects"
};

export default translates;
